module.exports = __webpack_public_path__ + "img/bg-family.b224bbaf.webp";